import { AASHTO_Aussere } from "./AASHTO_Aussere";
import { AASHTO_Innere } from "./AASHTO_Innere";

export function AASHTO({ data, settings }) {
  let showInnere = settings.find((item) => {
    return item.name === "aashtoInnere";
  });

  let showAussere = settings.find((item) => {
    return item.name === "aashtoAussere";
  });
  return (
    <>
      {showInnere && showInnere.value && <AASHTO_Innere data={data} />}
      {showAussere && showAussere.value && <AASHTO_Aussere data={data} />}
    </>
  );
}
